import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const Base_URL = `/uploads`;

export const uploadApi = async (type, body) => {
  const res = await axiosInstance.post(
    `${Base_URL}/init-upload/${type}`,
    body,
    getAuthHeaders(),
  );
  return res.data;
};

export const deleteFileApi = async (fileId, type) => {
  const res = await axiosInstance.delete(
    `/${type}/${fileId}`,
    getAuthHeaders(),
  );
  return res.data;
};

